import Component from '@glimmer/component';

import { concat, get } from '@ember/helper';
import { service } from '@ember/service';

import Sticky from 'rise-ui/components/sticky.gjs';
import ExpandingBlock from 'rise-ui/components/expanding-block.gjs';
import Item from 'rise-ui/components/time-series/selection/line/item.gjs';
import ModelRun from 'rise-ui/components/time-series/selection/line/model-run.gjs';
import itemsWithResult from 'rise-ui/helpers/items-with-result.js';
import notIn from 'rise-ui/helpers/not-in.js';
import parameterTimestep from 'rise-ui/helpers/parameter-timestep.js';
import parameterTransformation from 'rise-ui/helpers/parameter-transformation.js';
import parameterUnit from 'rise-ui/helpers/parameter-unit.js';
import string from 'rise-ui/helpers/string.js';
import titleCase from 'rise-ui/helpers/title-case.js';
import sticky from 'rise-ui/modifiers/sticky.js';

export default class TimeSeriesSelectionItemsComponent extends Component {
  @service('time-series/selected-locations') selectedLocations;

  <template>
    {{#each (itemsWithResult @items) as | item |}}
      {{#if (notIn this.selectedLocations.hidden.items item.id)}}
        {{#if item.isModeled}}
          <Sticky @name="item">
            <div class="c-sticky-subtitle">{{titleCase (string "catalog-item")}}</div>
            <div class="c-time-series-selection-line__label">
              {{#if item.parameter}}
                Modeled
                {{parameterTimestep item.parameter.parameterTimestep}}
                {{parameterTransformation item.parameter.parameterTransformation}}
                {{item.parameter.parameterName}}
                {{if item.parameter.parameterUnit
                  (concat "(" (parameterUnit item.parameter.parameterUnit) ")")
                }}
              {{else}}
                {{item.title}}
              {{/if}}
            </div>
          </Sticky>
          <ExpandingBlock
            @button={{true}}
            @initExpanded={{true}}
            @iconClass="c-time-series-selection-line__expander c-time-series-selection-line-item__expander"
          >
            <:head>
              <Item
                @item={{item}}
                @isSelected={{get @hasItem item.id}}
                @dateRanges={{get @itemDates item.id}}
                {{sticky activate="location record item"}}
              />
            </:head>
            <:body>
              {{#each item.validModelRuns as | modelRun |}}
                {{#if (notIn this.selectedLocations.hidden.modelRuns modelRun.id)}}
                  <ModelRun
                    @modelRun={{modelRun}}
                    @isValid={{get @isValidModelRun modelRun.id}}
                    @isSelected={{get @hasModelRun modelRun.id}}
                    @dateRanges={{get @modelRunDates modelRun.id}}
                    @datesRequired={{get @hasModelRun modelRun.id}}
                    {{sticky activate="location record item"}}
                  />
                {{/if}}
              {{/each}}
            </:body>
          </ExpandingBlock>
        {{else}}
          <Item
            @item={{item}}
            @isValid={{get @isValidItem item.id}}
            @isSelected={{get @hasItem item.id}}
            @dateRanges={{get @itemDates item.id}}
            @datesRequired={{get @hasItem item.id}}
            {{sticky activate="location record"}}
          />
        {{/if}}
      {{/if}}
    {{/each}}
  </template>
}
